import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './_guards/auth.guard';

import { AdminGuard } from './_guards';
import { ClientGuard } from './_guards';
import { StaffGuard } from './_guards';
import { ManagerGuard } from './_guards';
import { AgentGuard } from './_guards';

import { BlankLayoutComponent } from './components/common/layouts/blankLayout.component';
import { BasicLayoutComponent } from './components/common/layouts/basicLayout.component';
import { TopNavigationLayoutComponent } from './components/common/layouts/topNavigationLayout.component';
import { ClientLayoutComponent } from './components/common/layouts/clientLayout.component';

import { StaffLayoutComponent } from './components/common/layouts/staffLayout.component';
import { ManagerLayoutComponent } from './components/common/layouts/managerLayout.component';
import { AdminLayoutComponent } from './components/common/layouts/adminLayout.component';
import { AdminComponent } from './admin/admin.component';
import { TxcPrototypeComponent } from './admin/txc/txc-prototype/txc-prototype.component';
import { LogoutComponent } from './logout/logout.component';
import { ExampleTextControlComponent } from './example-text-control/example-text-control.component';
import { JobsHomeComponent } from './admin/jobs/jobs-home/jobs-home.component';
import { CommunicationComponent } from './communication/communication.component';
import { JobsDashboardComponent } from './admin/jobs/jobs-dashboard/jobs-dashboard.component';
import { JobsComponent } from './admin/jobs/jobs.component';
import { JobViewComponent } from './admin/jobs/job-view/job-view.component';
import { SubjectCardComponent } from './admin/jobs/subjects/subject-card/subject-card.component';
import { SubjectDocumentsComponent } from './admin/jobs/subjects/subject-documents/subject-documents.component';
import { EditDocxSystemFileComponent } from './admin/system-file-manager/edit-docx-system-file/edit-docx-system-file.component';
import { CommunicationManagerComponent } from './admin/communication-manager/communication-manager.component';
import { SubjectComTypeViewComponent } from './admin/communication-manager/subject-com-type-view/subject-com-type-view.component';
import { SubjectComTypeEditComponent } from './admin/communication-manager/subject-com-type-edit/subject-com-type-edit.component';
import { SubjectComTypeTemplateDocViewComponent } from './admin/communication-manager/subject-com-type-template-doc-view/subject-com-type-template-doc-view.component';
import { SubjectComTypeTemplateDocEditComponent } from './admin/communication-manager/subject-com-type-template-doc-edit/subject-com-type-template-doc-edit.component';
import { SubjectComTypeTemplateDocCreateComponent } from './admin/communication-manager/subject-com-type-template-doc-create/subject-com-type-template-doc-create.component';
import { EditDocxTemplateFileComponent } from './admin/communication-manager/edit-docx-template-file/edit-docx-template-file.component';
import { TxcMailMergeComponent } from './txc-mail-merge/txc-mail-merge.component';
import { JobsUrgentComponent } from './admin/jobs/jobs-urgent/jobs-urgent.component';
import { JobsClosedComponent } from './admin/jobs/jobs-closed/jobs-closed.component';
import { CreateJobComponent } from './admin/jobs/create-job/create-job.component';
import { CreateJob2Component } from './admin/jobs/create-job-2/create-job-2.component';
import { CreateJob3Component } from './admin/jobs/create-job-3/create-job-3.component';
import { EditJobComponent } from './admin/jobs/edit-job/edit-job.component';
import { SubjectCommunicationComponent } from './admin/jobs/subjects/subject-communication/subject-communication.component';
import { CompaniesHomeComponent } from './admin/companies-home/companies-home.component';
import { CompanyViewComponent } from './admin/companies-home/company-view/company-view.component';
import { CompanyEditComponent } from './admin/companies-home/company-edit/company-edit.component';
import { UsersListComponent } from './admin/users/users-list/users-list.component';
import { UserViewComponent } from './admin/users/user-view/user-view.component';
import { UserEditComponent } from './admin/users/user-edit/user-edit.component';
import { UserCreateComponent } from './admin/users/user-create/user-create.component';
import { CompanyCreateComponent } from './admin/companies-home/company-create/company-create.component';
import { SystemFileManagerComponent } from './admin/system-file-manager/system-file-manager.component';
import { SystemFileViewComponent } from './admin/system-file-manager/system-file-view/system-file-view.component';
import { SystemFileEditComponent } from './admin/system-file-manager/system-file-edit/system-file-edit.component';
import { SystemDocEditComponent } from './admin/system-file-manager/system-doc-edit/system-doc-edit.component';
import { ViewDocxSystemFileComponent } from './admin/system-file-manager/view-docx-system-file/view-docx-system-file.component';
import { SystemCommunicationHistoryComponent } from './admin/system-communication-history/system-communication-history.component';
import { SystemNoteManagerComponent } from './admin/system-note-manager/system-note-manager.component';
import { DocxThemeTemplateGridComponent } from './admin/communication-manager/docx-theme-template-grid/docx-theme-template-grid.component';
import { JobsSubjectsCreatedReportComponent } from './admin/system-reports/jobs-subjects-created-report/jobs-subjects-created-report.component';
import { AgentPerformanceMetricsComponent } from './admin/system-reports/agent-performance-metrics/agent-performance-metrics.component';
import { StaffPerformanceMetricsComponent } from './admin/system-reports/staff-performance-metrics/staff-performance-metrics.component';
import { NewSystemContactsReportComponent } from './admin/system-reports/new-system-contacts-report/new-system-contacts-report.component';
import { SystemLogManagerComponent } from './admin/system-log-manager/system-log-manager.component';
import { SystemSettingsComponent } from './admin/system-settings/system-settings.component';
import { SystemJobTypesComponent } from './admin/system-settings/system-job-types/system-job-types.component';
import { SystemJobTypeLocationsComponent } from './admin/system-settings/system-job-types/system-job-type-locations/system-job-type-locations.component';
import { SystemLocationCourtsComponent } from './admin/system-settings/system-job-types/system-location-courts/system-location-courts.component';
import { SystemCourtDocumentTypesComponent } from './admin/system-settings/system-job-types/system-court-document-types/system-court-document-types.component';
import { SystemDocumentTypeAffidavitsComponent } from './admin/system-settings/system-job-types/system-document-type-affidavits/system-document-type-affidavits.component';
import { SystemJobServiceRulesComponent } from './admin/system-settings/system-job-types/system-job-service-rules/system-job-service-rules.component';
import { SystemJobServiceTimeframesComponent } from './admin/system-settings/system-job-types/system-job-service-timeframes/system-job-service-timeframes.component';
import { SystemSubjectServiceTypesComponent } from './admin/system-settings/system-job-types/system-subject-service-types/system-subject-service-types.component';
import { AccountingBillingTasksComponent } from './admin/system-settings/accounting-billing-tasks/accounting-billing-tasks.component';
import { AccountingCostTasksComponent } from './admin/system-settings/accounting-cost-tasks/accounting-cost-tasks.component';
import { AccountingMyobAccountCodesComponent } from './admin/system-settings/accounting-myob-account-codes/accounting-myob-account-codes.component';
import { AccountingMyobTaxCodesComponent } from './admin/system-settings/accounting-myob-tax-codes/accounting-myob-tax-codes.component';
import { SubjectBillingTabComponent } from './admin/jobs/subjects/subject-billing-tab/subject-billing-tab.component';
import { SubjectCostTabComponent } from './admin/jobs/subjects/subject-cost-tab/subject-cost-tab.component';
import { InvoicesComponent } from './admin/accounting/invoices/invoices.component';
import { ClientOutstandingsComponent } from './admin/accounting/client-outstandings/client-outstandings.component';
import { PaymentsBulkComponent } from './admin/accounting/payments-bulk/payments-bulk.component';
import { MyobCustomersComponent } from './admin/accounting/myob-customers/myob-customers.component';
import { PaymentsComponent } from './admin/accounting/payments/payments.component';
import { InvoicesSuppliersComponent } from './admin/accounting/invoices-suppliers/invoices-suppliers.component';
import { AgentOutstandingsComponent } from './admin/accounting/agent-outstandings/agent-outstandings.component';
import { PaymentsBulkSupplierComponent } from './admin/accounting/payments-bulk-supplier/payments-bulk-supplier.component';
import { MyobSuppliersComponent } from './admin/accounting/myob-suppliers/myob-suppliers.component';
import { MyobPaymentsSuppliersComponent } from './admin/accounting/myob-payments-suppliers/myob-payments-suppliers.component';
import { MyobLoginComponent } from './admin/myob-login/myob-login.component';
import { StaffDashboardComponent } from './staff/staff-dashboard/staff-dashboard.component';
import { CreateJobTypeComponent } from './admin/jobs/create-job-type/create-job-type.component';
import { CreateJobStatusComponent } from './admin/jobs/create-job-status/create-job-status.component';
import { SubjectNotesTabComponent } from './admin/jobs/subjects/subject-notes-tab/subject-notes-tab.component';
import { ClientDashboardComponent } from './client/client-dashboard/client-dashboard.component';
import { ClientJobsComponent } from './client/client-jobs/client-jobs.component';
import { ClientJobCreateComponent } from './client/client-jobs/client-job-create/client-job-create.component';
import { ClientJobCreate2Component } from './client/client-jobs/client-job-create2/client-job-create2.component';
import { ClientJobCreate3Component } from './client/client-jobs/client-job-create3/client-job-create3.component';
import { ClientJobViewComponent } from './client/client-jobs/client-job-view/client-job-view.component';
import { ClientJobSubjectComponent } from './client/client-jobs/client-job-subject/client-job-subject.component';
import { ClientProfileComponent } from './client/client-profile/client-profile.component';
import { ClientProfileEditComponent } from './client/client-profile-edit/client-profile-edit.component';
import { ClientUserProfileComponent } from './client/client-user-profile/client-user-profile.component';
import { ClientUserProfileEditComponent } from './client/client-user-profile-edit/client-user-profile-edit.component';
import { ClientUsersComponent } from './client/client-users/client-users.component';
import { AgentLayoutComponent } from './components/common/layouts/agentLayout.component';
import { AgentComponent } from './agent/agent/agent.component';
import { AgentJobsComponent } from './agent/agent-jobs/agent-jobs.component';
import { AgentViewSubjectComponent } from './agent/agent-view-subject/agent-view-subject.component';
import { AgentJobViewComponent } from './agent/agent-job-view/agent-job-view.component';
import { AgentJobSubjectComponent } from './agent/agent-job-subject/agent-job-subject.component';
import { AgentProfileComponent } from './agent/agent-profile/agent-profile.component';
import { AgentProfileEditComponent } from './agent/agent-profile-edit/agent-profile-edit.component';
import { AgentUserProfileComponent } from './agent/agent-user-profile/agent-user-profile.component';
import { AgentUserProfileEditComponent } from './agent/agent-user-profile-edit/agent-user-profile-edit.component';
import { AgentUsersComponent } from './agent/agent-users/agent-users.component';
import { EditDocxThemeFileComponent } from './admin/system-file-manager/edit-docx-theme-file/edit-docx-theme-file.component';
import { LostPasswordComponent } from './views/lost-password/lost-password.component';
import { SubjectComTypeCreateComponent } from './admin/communication-manager/subject-com-type-create/subject-com-type-create.component';
import { ReportNewAgentContactsComponent } from './admin/system-reports/new-system-contacts-report/report-new-agent-contacts/report-new-agent-contacts.component';
import { ClientInvoicesComponent } from './client/client-invoices/client-invoices.component';
import { AgentInvoicesComponent } from './agent/agent-invoices/agent-invoices.component';
import { ClientJobCreateWizardStep1Component } from './client/client-jobs/client-job-create-wizard-step1/client-job-create-wizard-step1.component';
import { ClientJobCreateWizardStep2Component } from './client/client-jobs/client-job-create-wizard-step2/client-job-create-wizard-step2.component';
import { ClientJobCreateWizardStep3Component } from './client/client-jobs/client-job-create-wizard-step3/client-job-create-wizard-step3.component';
import { ClientJobsUrgentComponent } from './client/client-jobs-urgent/client-jobs-urgent.component';
import { ClientJobStatusKeyWidgetComponent } from './client/client-job-status-key-widget/client-job-status-key-widget.component';
import { SystemInvestigationComponent } from './admin/system-investigation/system-investigation.component';
import { SystemActionListsComponent } from './admin/system-action-lists/system-action-lists.component';
import { SystemActionListComponent } from './admin/system-action-list/system-action-list.component';
import { SystemLogViewComponent } from './admin/system-log-manager/system-log-view/system-log-view.component';
import { SystemLogTypesComponent } from './admin/system-settings/system-log-types/system-log-types.component';
import { UpdateSystemLogTypeComponent } from './admin/system-settings/update-system-log-type/update-system-log-type.component';
import { SystemAutomationsComponent } from './admin/system-automations/system-automations/system-automations.component';
import { SystemAutomationCreateComponent } from './admin/system-automations/system-automation-create/system-automation-create.component';
import { SystemAutomationUpdateComponent } from './admin/system-automations/system-automation-update/system-automation-update.component';
import { SystemAutomationComponent } from './admin/system-automations/system-automation/system-automation.component';
import { VariableCodeBlocksComponent } from './admin/system-variables/variable-code-blocks/variable-code-blocks.component';
import { VariableCodeBlockCreateComponent } from './admin/system-variables/variable-code-block-create/variable-code-block-create.component';
import { VariableCodeBlockUpdateComponent } from './admin/system-variables/variable-code-block-update/variable-code-block-update.component';
import { SystemLogTypeDataSectorConditionsComponent } from './admin/system-settings/system-log-type-data-sector-conditions/system-log-type-data-sector-conditions.component';
import { SystemLogTypeDataSectorConditionUpdateComponent } from './admin/system-settings/system-log-type-data-sector-condition-update/system-log-type-data-sector-condition-update.component';
import { SystemLogTypeDataSectorsComponent } from './admin/system-settings/system-log-type-data-sectors/system-log-type-data-sectors.component';
import { SystemLogTypeDataSectorUpdateComponent } from './admin/system-settings/system-log-type-data-sector-update/system-log-type-data-sector-update.component';
import { SystemLogTypeComponent } from './admin/system-settings/system-log-type/system-log-type.component';
import { SystemLogTypeDataSectorComponent } from './admin/system-settings/system-log-type-data-sector/system-log-type-data-sector.component';
import { SystemLogTypeDataSectorTypesComponent } from './admin/system-settings/system-log-type-data-sector-types/system-log-type-data-sector-types.component';
import { SystemLogTypeDataSectorTypeUpdateComponent } from './admin/system-settings/system-log-type-data-sector-type-update/system-log-type-data-sector-type-update.component';
import { SystemLogTypeDataSectorTypeComponent } from './admin/system-settings/system-log-type-data-sector-type/system-log-type-data-sector-type.component';
import { SystemLogTypeDataSectorConditionComponent } from './admin/system-settings/system-log-type-data-sector-condition/system-log-type-data-sector-condition.component';
import { SubjectServiceOutcomeTemplatesComponent } from './admin/system-settings/subject-service-outcome-templates/subject-service-outcome-templates.component';
import { SubjectServiceOutcomeTemplate } from './shared/models/subjectServiceOutcomeTemplate.model';
import { SubjectServiceOutcomeTemplateComponent } from './admin/system-settings/subject-service-outcome-template/subject-service-outcome-template.component';
import { SubjectServiceOutcomeTemplateUpdateComponent } from './admin/system-settings/subject-service-outcome-template-update/subject-service-outcome-template-update.component';
import { AppRoutesComponent } from './admin/system-routes/app-routes/app-routes.component';
import { AppRouteCreateComponent } from './admin/system-routes/app-route-create/app-route-create.component';
import { AppRouteUpdateComponent } from './admin/system-routes/app-route-update/app-route-update.component';
import { AppRouteComponent } from './admin/system-routes/app-route/app-route.component';
import { ProjectsHomeComponent } from './admin/jobs/projects-home/projects-home.component';
import { ProjectsEditComponent } from './admin/jobs/projects-home/projects-edit/projects-edit.component';
import { ProjectAdminViewComponent } from './admin/jobs/projects-home/project-admin-view/project-admin-view.component';
import { SubjectCommunicationWithVarsComponent } from './admin/jobs/subjects/subject-communication-with-vars/subject-communication-with-vars.component';
import { SubjectUrgentOutcomeTemplatesComponent } from './admin/system-settings/subject-urgent-outcome-templates/subject-urgent-outcome-templates.component';
import { SubjectUrgentOutcomeTemplateUpdateComponent } from './admin/system-settings/subject-urgent-outcome-template-update/subject-urgent-outcome-template-update.component';
import { SubjectUrgentOutcomeTemplateComponent } from './admin/system-settings/subject-urgent-outcome-template/subject-urgent-outcome-template.component';
import { SubjectCardLayoutsDashboardComponent } from './admin/jobs/subjects/subject-card-layouts-dashboard/subject-card-layouts-dashboard.component';
import { Login2FAComponent } from './login2-fa/login2-fa.component';
import { LoginEnterCodeTFAComponent } from './login-enter-code-tfa/login-enter-code-tfa.component';
import { LoginUserSetupTFAComponent } from './login-user-setup-tfa/login-user-setup-tfa.component';
import { JobsSortingComponent } from './admin/jobs/jobs-sorting/jobs-sorting.component';
import { SystemActivityDashbardComponent } from './admin/system-reports/activity/system-activity-dashbard/system-activity-dashbard.component';
import { LogTypeBenchmarksComponent } from './admin/system-reports/benchmarks/log-type-benchmarks/log-type-benchmarks.component';
import { LogTypeBenchmarkUpdateComponent } from './admin/system-reports/benchmarks/log-type-benchmark-update/log-type-benchmark-update.component';
import { LogTypeBenchmarkComponent } from './admin/system-reports/benchmarks/log-type-benchmark/log-type-benchmark.component';
import { StaffPerformanceMetricsDashboardComponent } from './admin/system-reports/staff-performance-metrics/staff-performance-metrics-dashboard/staff-performance-metrics-dashboard.component';
import { BenchmarkpiGroupsComponent } from './admin/system-reports/benchmarks/benchmarkpi-groups/benchmarkpi-groups.component';
import { BenchmarkpiGroupViewComponent } from './admin/system-reports/benchmarks/benchmarkpi-group-view/benchmarkpi-group-view.component';
import { BenchmarkpiGroupUpdateComponent } from './admin/system-reports/benchmarks/benchmarkpi-group-update/benchmarkpi-group-update.component';
import { StaffPerformanceMetricsSavedDashboardComponent } from './admin/system-reports/staff-performance-metrics/staff-performance-metrics-saved-dashboard/staff-performance-metrics-saved-dashboard.component';
import { AgentPerformanceMetricsDashboardComponent } from './admin/system-reports/agent-performance-metrics/agent-performance-metrics-dashboard/agent-performance-metrics-dashboard.component';
import { AgentPerformanceMetricsSavedDashboardComponent } from './admin/system-reports/agent-performance-metrics/agent-performance-metrics-saved-dashboard/agent-performance-metrics-saved-dashboard.component';
import { ClientPerformanceMetricsComponent } from './admin/system-reports/client-performance-metrics/client-performance-metrics.component';
import { ClientPerformanceMetricsSavedDashboardComponent } from './admin/system-reports/client-performance-metrics/client-performance-metrics-saved-dashboard/client-performance-metrics-saved-dashboard.component';
import { AgentPerformanceMetricsAttemptsDashboardComponent } from './admin/system-reports/agent-performance-metrics/agent-performance-metrics-attempts-dashboard/agent-performance-metrics-attempts-dashboard.component';
import { AgentPerformanceMetricsAttemptBenchmarksComponent } from './admin/system-reports/agent-performance-metrics/agent-performance-metrics-attempt-benchmarks/agent-performance-metrics-attempt-benchmarks.component';
import { DbeRestAdminComponent } from './admin/system-settings/dbe-rest-admin/dbe-rest-admin.component';
import { DbeRestReportComponent } from './admin/system-settings/dbe-rest-report/dbe-rest-report.component';
import { ClientApiOnboardingComponent } from './admin/system-settings/client-api-onboarding/client-api-onboarding.component';
import { SystemNoticeBannerComponent } from './admin/system-notices/system-notice-banner/system-notice-banner.component';
import { SystemNoticeCreateComponent } from './admin/system-notices/system-notice-create/system-notice-create.component';
import { SystemNoticeUpdateComponent } from './admin/system-notices/system-notice-update/system-notice-update.component';
import { SystemNoticesComponent } from './admin/system-notices/system-notices/system-notices.component';
import { TimeframeSurchargesComponent } from './admin/system-settings/timeframe-surcharges/timeframe-surcharges.component';
import { JobsUrgentTimeframesComponent } from './admin/jobs/jobs-urgent-timeframes/jobs-urgent-timeframes.component';
import { SubjectsUrgentExportJobSchedulesComponent } from './admin/system-reports/subjects-urgent-export-job-schedules/subjects-urgent-export-job-schedules.component';
import { ClientJobsUrgentTimeframesComponent } from './client/client-jobs-urgent-timeframes/client-jobs-urgent-timeframes.component';
import { AgentJobsUrgentTimeframesComponent } from './agent/agent/agent-jobs-urgent-timeframes/agent-jobs-urgent-timeframes.component';
import { SubjectServiceResolutionOutcomesComponent } from './admin/system-settings/subject-service-resolution-outcomes/subject-service-resolution-outcomes.component';
import { AgentPerformanceActivityMetricsAttemptAttemptsComponent } from './admin/system-reports/agent-performance-activity-metrics/agent-performance-activity-metrics-attempt-attempts/agent-performance-activity-metrics-attempt-attempts.component';
import { AgentPerformanceActivityMetricsAttemptsComponent } from './admin/system-reports/agent-performance-activity-metrics/agent-performance-activity-metrics-attempts/agent-performance-activity-metrics-attempts.component';
import { AgentPerformanceActivityMetricsProgressComponent } from './admin/system-reports/agent-performance-activity-metrics/agent-performance-activity-metrics-progress/agent-performance-activity-metrics-progress.component';
import { AgentPerformanceActivityMetricsAttemptsIndexedComponent } from './admin/system-reports/agent-performance-activity-metrics/agent-performance-activity-metrics-attempts-indexed/agent-performance-activity-metrics-attempts-indexed.component';
import { AgentPerformanceActivityMetricsDashboardIndexedComponent } from './admin/system-reports/agent-performance-activity-metrics/agent-performance-activity-metrics-dashboard-indexed/agent-performance-activity-metrics-dashboard-indexed.component';

  // import { AppRouteCreateComponent } from './admin/system-routes/app-route-create/app-route-create.component';
  // import { AppRouteUpdateComponent } from './admin/system-routes/app-route-update/app-route-update.component';
  // import { AppRouteComponent } from './admin/system-routes/app-route/app-route.component';
  // import { AppRoutesComponent } from './admin/system-routes/app-routes/app-routes.component';


export const routes: Routes = [
  // Fallback when no prior route is matched
  

//  { path: 'home', component: HomeComponent,  },
  // { path: 'admin', component: AdminComponent,  },



  

  // { path: 'jobs', component: JobsHomeComponent },
  // { path: 'example', component: ExampleTextControlComponent },
  // { path: 'communication', component: CommunicationComponent },
  // { path: 'logout', component: LogoutComponent },
  // { path: 'login', component: LoginComponent },

  {
    path: 'login', component: BlankLayoutComponent,
    children: [
      { path: '', component: LoginComponent },
      // { path: 'list', component: ProjectsComponent },
    ]
  },
  {
    path: 'logout', component: BlankLayoutComponent,
    children: [
      { path: '', component: LogoutComponent },
      // { path: 'list', component: ProjectsComponent },
    ]
  },

  // {
  //   path: 'example', component: BasicLayoutComponent,
  //   children: [
  //     { path: '', component: ExampleTextControlComponent },
  //     // { path: 'list', component: ProjectsComponent },
  //   ]
  // },

  {
    path: 'communication', component: AdminLayoutComponent, canActivate: [AdminGuard],
    children: [
      { path: '', component: CommunicationComponent },
      // { path: 'list', component: ProjectsComponent },
    ]
  },

  // {
  // //   path: 'admin', component: AdminLayoutComponent, canActivate: [AdminGuard],
  // //   children: [
  // //     { path: '', component: AdminComponent },
  // //     // { path: 'list', component: ProjectsComponent },
  // //     { path: 'jobs', component: JobsHomeComponent },
  // //     // { path: '', component: JobsHomeComponent },
  // //   ]
  // // },

  {
    path: 'home', component: BasicLayoutComponent,
    children: [
     { path: '', component: HomeComponent },
      // { path: 'list', component: ProjectsComponent },
    ]
  },


  // TFA sectioned Area
  // {
  //   path: 'tfa', component: BlankLayoutComponent, canActivate: [  ClientGuard],
  //   children: [
  //     { path: 'tfa_setup', component: LoginUserSetupTFAComponent , canActivate: [ ClientGuard] }, // Now initalise  a 2fa here.
  //     { path: 'tfa_enter_code', component: LoginEnterCodeTFAComponent, canActivate: [ ClientGuard]}, // Now initalise  a 2fa here.
  //   ]
  // },
  // {
  //   path: 'admin-tfa', component: BlankLayoutComponent, canActivate: [ AdminGuard],
  //   children: [
  //     { path: 'tfa_setup', component: LoginUserSetupTFAComponent , canActivate: [ AdminGuard] }, // Now initalise  a 2fa here.
  //     { path: 'tfa_enter_code', component: LoginEnterCodeTFAComponent , canActivate: [ AdminGuard]}, // Now initalise  a 2fa here.
  //   ]
  // },




  {
    path: 'example', component: AdminLayoutComponent, canActivate: [AdminGuard],
    children: [
      { path: '', component: ExampleTextControlComponent },
      // { path: 'jobs', component: JobsHomeComponent },
    ]
  },
  {
    path: 'jobs', component: AdminLayoutComponent, canActivate: [AdminGuard],
    children: [
      { path: '', component: JobsHomeComponent },
      // { path: 'jobs', component: JobsHomeComponent },
    ]
  },




// staff NEW Proper
{
  path: 'staff', component: StaffLayoutComponent, canActivate: [StaffGuard],
  children: [
    // { path: '', component: StaffDashboardComponent , canActivate: [StaffGuard]},
    { path: '', component: LoginEnterCodeTFAComponent , canActivate: [StaffGuard]},
   
    { path: 'tfa_setup', component: LoginUserSetupTFAComponent, canActivate: [StaffGuard] }, // Now initalise  a 2fa here.
    { path: 'tfa_enter_code', component: LoginEnterCodeTFAComponent, canActivate: [StaffGuard] }, // Now initalise  a 2fa here.

    { path: 'dashboard', component: StaffDashboardComponent , canActivate: [StaffGuard]},
//     // { path: 'traces', component: StaffMemberTracesComponent },
//     // { path: 'traces/search', component: StaffMemberTracesSearchComponent },
//     { path: 'traces/subjects/search', component: StaffMemberSubjectsSearchComponent },
//     // { path: 'traces/trace/:trace_id', component: StaffMemberTraceComponent },
//     // { path: 'traces/trace-candidate/:trace_id/:trace_candidate_id/:candidate_trace_number', component: TraceCandidateComponent },

// // New Staf Global Routes from admin compoinents 2022

    { path: 'jobs/urgent', component: JobsUrgentComponent, canActivate: [StaffGuard] },
    { path: 'jobs/home', component: JobsHomeComponent, canActivate: [StaffGuard] },
    { path: 'jobs/closed', component: JobsClosedComponent, canActivate: [StaffGuard] },

       { path: 'jobs/timeframes-urgent', component: JobsUrgentTimeframesComponent, canActivate: [StaffGuard] },
   
//     // { path: 'jobs/subject/edit/:subject_id', component: SubjectEditComponent, canActivate: [StaffGuard] },
//     // { path: 'jobs/subject/view/:subject_id', component: SubjectViewComponent, canActivate: [StaffGuard] },

    { path: 'jobs/subject/edit/:subject_id', component: SubjectCardComponent, canActivate: [StaffGuard] },
    { path: 'jobs/subject/view/:subject_id', component: SubjectCardComponent, canActivate: [StaffGuard] },

    { path: 'jobs/subject/edit/dashboard/:subject_id', component: SubjectCardLayoutsDashboardComponent, canActivate: [StaffGuard] },

    { path: 'jobs/subject/communication/:subject_id', component: SubjectCommunicationComponent, canActivate: [StaffGuard] },
    { path: 'jobs/subject/communication-with-vars/:subject_id', component: SubjectCommunicationWithVarsComponent, canActivate: [StaffGuard] },


    { path: '', component: JobsDashboardComponent, canActivate: [StaffGuard] },
    { path: 'jobs', component: JobsComponent, canActivate: [StaffGuard] },
    { path: 'jobs/create-job', component: CreateJobComponent, canActivate: [StaffGuard] },
//     // { path: 'jobs/agrid', component: AgridComponent, canActivate: [StaffGuard] },
    { path: 'jobs/create-job-2/:job_id', component: CreateJob2Component, canActivate: [StaffGuard] },
    { path: 'jobs/create-job-3/:job_id', component: CreateJob3Component, canActivate: [StaffGuard] },
    // { path: 'clients', component: ClientsComponent, canActivate: [StaffGuard] },
//     { path: 'clients/create-client', component: ClientCreateComponent, canActivate: [StaffGuard] },
//     { path: 'clients/contacts/:client_id', component: ClientContactsSharmansComponent, canActivate: [StaffGuard] },
    { path: 'jobs/edit/:job_id', component: EditJobComponent, canActivate: [StaffGuard] },
    { path: 'jobs/create-job-type', component: CreateJobTypeComponent, canActivate: [StaffGuard] },
    { path: 'jobs/create-job-status', component: CreateJobStatusComponent, canActivate: [StaffGuard] },
    { path: 'jobs/view/:job_id', component: JobViewComponent, canActivate: [StaffGuard] },
//     { path: 'jobs/view/history/:job_id', component: JobHistoryComponent, canActivate: [StaffGuard] },
//     // doc editor
  //     { path: 'jobs/subject/communication/docx-view/:file_id', component: ViewDocxSubjectFileComponent, canActivate: [StaffGuard] },
  //     { path: 'jobs/subject/communication/docx-edit/:file_id', component: EditDocxSubjectFileComponent, canActivate: [StaffGuard] },

    { path: 'jobs/subject/documents/:subject_id', component: SubjectDocumentsComponent, canActivate: [StaffGuard] },
    { path: 'jobs/subject/notes/:subject_id', component: SubjectNotesTabComponent, canActivate: [StaffGuard] },
    // { path: 'jobs/subject/attendance/:subject_id', component: SubjectAttendanceTabComponent, canActivate: [StaffGuard] },
    { path: 'jobs/subject/billing/:subject_id', component: SubjectBillingTabComponent, canActivate: [StaffGuard] },
    { path: 'jobs/subject/cost/:subject_id', component: SubjectCostTabComponent, canActivate: [StaffGuard] },

    { path: 'system-file-manager', component: SystemFileManagerComponent, canActivate: [StaffGuard] },
    { path: 'system-file-manager/system-file/:file_id', component: SystemFileViewComponent , canActivate: [StaffGuard]},
    { path: 'system-file-manager/system-file-edit/:file_id', component: SystemFileEditComponent, canActivate: [StaffGuard] },
    { path: 'system-file-manager/system-doc-edit/:file_id', component: SystemDocEditComponent, canActivate: [StaffGuard] },
//     // doc editor
    { path: 'system-file-manager/system-doc-edit/docx-view/:file_id', component: ViewDocxSystemFileComponent, canActivate: [StaffGuard] },
    { path: 'system-file-manager/system-doc-edit/docx-edit/:file_id', component: EditDocxSystemFileComponent, canActivate: [StaffGuard] },
//     // doc editor HTML
    // { path: 'system-file-manager/system-doc-edit/docx-view-html/:file_id',
    //  component: ViewDocxSystemFileHtmlComponent, canActivate: [StaffGuard] },
//     // Start of Brands
//     // { path: 'brands', component: BrandsComponent },
//     // { path: 'brands/create', component: CreateBrandComponent },
//     // { path: 'brand/update/:brand_id', component: UpdateBrandComponent },
//     // { path: 'brand/:brand_id', component: BrandComponent },
//     // { path: 'client-brands/:brand_id', component: ClientBrandsComponent },
//     // { path: 'client-brand/:client_brand_id', component: ClientBrandComponent },
//     // { path: 'brand-client-manager/:brand_id', component: BrandClientManagerComponent },
//     // { path: 'brand-client-create/:brand_id', component: BrandClientCreateComponent, canActivate: [StaffGuard] },
//     // brand client contacts
//     //  {path: 'brand-client-contact-manger/:client_brand_id', component: BrandClientContactManagerComponent},
//     // { path: 'brand-client-contact-manger/:brand_id/:client_brand_id', component: BrandClientContactManagerComponent },

//     // Brand User Manager
//     // { path: 'brand-user-manager/:brand_id', component: BrandUserManagerComponent },

    { path: 'brands/companies', component: CompaniesHomeComponent , canActivate: [StaffGuard]},
    { path: 'brands/users', component: UsersListComponent , canActivate: [StaffGuard]},
    { path: 'brands/users/view/:user_id', component: UserViewComponent , canActivate: [StaffGuard]},
    { path: 'brands/users/edit/:user_id', component: UserEditComponent , canActivate: [StaffGuard]},
    { path: 'brands/users/create', component: UserCreateComponent, canActivate: [StaffGuard] },
    { path: 'brands/company/create', component: CompanyCreateComponent, canActivate: [StaffGuard] },
    { path: 'brands/company/view/:brand_id', component: CompanyViewComponent, canActivate: [StaffGuard] },
    { path: 'brands/company/edit/:brand_id', component: CompanyEditComponent, canActivate: [StaffGuard] },



    // new if staff_accounting_access = 1
  
    // Duplicate navigation for all Accouting services.
  
//     // accounting
//     { path: 'accounting', component: AccountingComponent, canActivate: [AdminGuard] },
    { path: 'accounting/invoices', component: InvoicesComponent, canActivate: [StaffGuard] },
//     { path: 'accounting/create-invoice', component: CreateInvoiceComponent, canActivate: [AdminGuard] },
//       // orginal paths
    { path: 'accounting/myob-login', component: MyobLoginComponent, canActivate: [StaffGuard] },
    { path: 'myob-login', component: MyobLoginComponent, canActivate: [StaffGuard] },
//     { path: 'accounting/myob-customers', component: MyobCustomersComponent, canActivate: [AdminGuard] },
//     { path: 'accounting/payments', component: PaymentsComponent, canActivate: [AdminGuard] },
//     { path: 'accounting/payments-bulk', component: PaymentsBulkComponent, canActivate: [AdminGuard] },
//       // Three level navigation
//           // clients
    { path: 'accounting/client/invoices', component: InvoicesComponent, canActivate: [StaffGuard] },
    { path: 'accounting/client/outstandings', component: ClientOutstandingsComponent, canActivate: [StaffGuard] },
    { path: 'accounting/client/paymentbulk', component: PaymentsBulkComponent, canActivate: [StaffGuard] },
    { path: 'accounting/client/myob-customers', component: MyobCustomersComponent, canActivate: [StaffGuard] },
    { path: 'accounting/client/payments', component: PaymentsComponent, canActivate: [StaffGuard] },
//           // agents
    { path: 'accounting/agent/invoices', component: InvoicesSuppliersComponent, canActivate: [StaffGuard] },
    { path: 'accounting/agent/outstandings', component: AgentOutstandingsComponent, canActivate: [StaffGuard] },
    { path: 'accounting/agent/paymentbulk', component: PaymentsBulkSupplierComponent, canActivate: [StaffGuard] },
    { path: 'accounting/agent/myob-customers', component: MyobSuppliersComponent, canActivate: [StaffGuard] },
    { path: 'accounting/agent/payments', component: MyobPaymentsSuppliersComponent, canActivate: [StaffGuard] },

    // accounting settings
          { path: 'system-settings/accounting/billing-tasks', component: AccountingBillingTasksComponent, canActivate: [StaffGuard] },
       { path: 'system-settings/accounting/cost-tasks', component: AccountingCostTasksComponent, canActivate: [StaffGuard] },

       { path: 'system-settings/accounting/myob-account-codes', component: AccountingMyobAccountCodesComponent, canActivate: [StaffGuard] },
       { path: 'system-settings/accounting/myob-tax-codes', component: AccountingMyobTaxCodesComponent, canActivate: [StaffGuard] },


// end is_staff_accounting_access = 1





  ]
},







// Administration NEW Proper
{
  //  path: 'admin', component: AdminLayoutComponent, canActivate: [ AdminGuard],
  path: 'admin', component: AdminLayoutComponent, canActivate: [AdminGuard],
  children: [
    // { path: '', component: JobsDashboardComponent, canActivate: [AdminGuard] }, //original
    { path: '', component: LoginEnterCodeTFAComponent, canActivate: [AdminGuard] }, // Now initalise  a 2fa here. -- use this to load enter code after deffault login.
    
// { path: 'dashboard', component: JobsDashboardComponent, canActivate: [AdminGuard] }, //original

    { path: 'tfa_setup_working', component: Login2FAComponent, canActivate: [AdminGuard] }, // Now initalise  a 2fa here. -- use this to load setup as default login

    { path: 'tfa_setup', component: LoginUserSetupTFAComponent, canActivate: [AdminGuard] }, // Now initalise  a 2fa here.
    { path: 'tfa_enter_code', component: LoginEnterCodeTFAComponent, canActivate: [AdminGuard] }, // Now initalise  a 2fa here.
    
    // { path: '', component: JobsDashboardComponent, canActivate: [AdminGuard] },
    { path: 'jobs', component: JobsComponent, canActivate: [AdminGuard] },
    { path: 'jobs/create-job', component: CreateJobComponent, canActivate: [AdminGuard] },
//     // { path: 'jobs/agrid', component: AgridComponent, canActivate: [AdminGuard] },
    { path: 'jobs/create-job-2/:job_id', component: CreateJob2Component, canActivate: [AdminGuard] },
    { path: 'jobs/create-job-3/:job_id', component: CreateJob3Component, canActivate: [AdminGuard] },
//     { path: 'clients', component: ClientsComponent, canActivate: [AdminGuard] },
//     { path: 'clients/create-client', component: ClientCreateComponent, canActivate: [AdminGuard] },
//     { path: 'clients/contacts/:client_id', component: ClientContactsSharmansComponent, canActivate: [AdminGuard] },
    { path: 'jobs/edit/:job_id', component: EditJobComponent, canActivate: [AdminGuard] },
//     { path: 'jobs/create-job-type', component: CreateJobTypeComponent, canActivate: [AdminGuard] },
//     { path: 'jobs/create-job-status', component: CreateJobStatusComponent, canActivate: [AdminGuard] },




    { path: 'jobs/view/:job_id', component: JobViewComponent, canActivate: [AdminGuard] },
//     { path: 'jobs/view/history/:job_id', component: JobHistoryComponent, canActivate: [AdminGuard] },

    { path: 'jobs/dashboard', component: JobsDashboardComponent, canActivate: [AdminGuard] },
    { path: 'jobs/urgent', component: JobsUrgentComponent, canActivate: [AdminGuard] },

    { path: 'jobs/timeframes-urgent', component: JobsUrgentTimeframesComponent, canActivate: [AdminGuard] },


    { path: 'jobs/home', component: JobsHomeComponent, canActivate: [AdminGuard] },
    { path: 'jobs/closed', component: JobsClosedComponent, canActivate: [AdminGuard] },
    { path: 'jobs/sorting', component: JobsSortingComponent, canActivate: [AdminGuard] },

    { path: 'jobs/subject/edit/:subject_id', component: SubjectCardComponent, canActivate: [AdminGuard] },
    { path: 'jobs/subject/edit/dashboard/:subject_id', component: SubjectCardLayoutsDashboardComponent, canActivate: [AdminGuard] },

// // subject card August 2022
{ path: 'jobs/subject/card/:subject_id', component: SubjectCardComponent, canActivate: [AdminGuard] },
{ path: 'jobs/subject/card/dashboard/:subject_id', component: SubjectCardLayoutsDashboardComponent, canActivate: [AdminGuard] },
{ path: 'jobs/subject/view/:subject_id', component: SubjectCardComponent, canActivate: [AdminGuard] },


    { path: 'jobs/subject/communication/:subject_id', component: SubjectCommunicationComponent, canActivate: [AdminGuard] },
    { path: 'jobs/subject/communication-with-vars/:subject_id', component: SubjectCommunicationWithVarsComponent, canActivate: [AdminGuard] },


//     // doc editor
//     { path: 'jobs/subject/communication/docx-view/:file_id', component: ViewDocxSubjectFileComponent, canActivate: [AdminGuard] },
//     { path: 'jobs/subject/communication/docx-edit/:file_id', component: EditDocxSubjectFileComponent, canActivate: [AdminGuard] },

    { path: 'jobs/subject/documents/:subject_id', component: SubjectDocumentsComponent, canActivate: [AdminGuard] },
//     { path: 'jobs/subject/notes/:subject_id', component: SubjectNotesTabComponent, canActivate: [AdminGuard] },
//     { path: 'jobs/subject/attendance/:subject_id', component: SubjectAttendanceTabComponent, canActivate: [AdminGuard] },
    { path: 'jobs/subject/billing/:subject_id', component: SubjectBillingTabComponent, canActivate: [AdminGuard] },
    { path: 'jobs/subject/cost/:subject_id', component: SubjectCostTabComponent, canActivate: [AdminGuard] },
    

//     // Start of Communication Manger
    { path: 'communication', component: CommunicationManagerComponent , canActivate: [AdminGuard] },
    { path: 'communication/com_type_view/:subject_com_type_id', component: SubjectComTypeViewComponent , canActivate: [AdminGuard] },
    { path: 'communication/com_type_edit/:subject_com_type_id', component: SubjectComTypeEditComponent, canActivate: [AdminGuard]  },
    { path: 'communication/com_type_create', component: SubjectComTypeCreateComponent , canActivate: [AdminGuard] },

    { path: 'communication/com_type_template_doc_view/:doc_id', component: SubjectComTypeTemplateDocViewComponent, canActivate: [AdminGuard]  },
    { path: 'communication/com_type_template_doc_edit/:doc_id', component: SubjectComTypeTemplateDocEditComponent , canActivate: [AdminGuard] },
    { path: 'communication/com_type_template_doc_create/:subject_com_type_id', component: SubjectComTypeTemplateDocCreateComponent, canActivate: [AdminGuard]  },
    { path: 'communication/template_doc_view/template/:doc_id', component: EditDocxTemplateFileComponent , canActivate: [AdminGuard] },
//     { path: 'communication/template_doc_view/template-view/:doc_id', component: ViewDocxTemplateFileComponent },
    
//     // :: Samples for DocxEditor Creation
//     { path: 'communication/template_doc_view/sample-dropdown/:doc_id', component: SampleFileDropDownComponent },
//     { path: 'communication/template_doc_view/sample-file-server-load-docx/:doc_id', component: SampleFileServerLoadDocxEditorComponent },


//     // :: Job Types Manager (System Settings)
//     { path: 'communication/template_doc_view/sample-dropdown/:doc_id', component: SampleFileDropDownComponent },
//     { path: 'communication/template_doc_view/sample-file-server-load-docx/:doc_id', component: SampleFileServerLoadDocxEditorComponent },


    { path: 'system-file-manager', component: SystemFileManagerComponent, canActivate: [AdminGuard]  },
    { path: 'system-file-manager/system-file/:file_id', component: SystemFileViewComponent , canActivate: [AdminGuard] },
    { path: 'system-file-manager/system-file-edit/:file_id', component: SystemFileEditComponent , canActivate: [AdminGuard] },
    { path: 'system-file-manager/system-doc-edit/:file_id', component: SystemDocEditComponent, canActivate: [AdminGuard]  },
//     // doc editor
    { path: 'system-file-manager/system-doc-edit/docx-view/:file_id', component: ViewDocxSystemFileComponent, canActivate: [AdminGuard] },
    { path: 'system-file-manager/system-doc-edit/docx-edit/:file_id', component: EditDocxSystemFileComponent, canActivate: [AdminGuard] },


          { path: 'system-theme-file-manager', component: DocxThemeTemplateGridComponent },
          { path: 'system-file-manager/system-doc-edit/theme-docx-edit/:file_id/:filename', component: EditDocxThemeFileComponent, canActivate: [AdminGuard] },
          

//     // doc editor HTML
//     { path: 'system-file-manager/system-doc-edit/docx-view-html/:file_id',
//      component: ViewDocxSystemFileHtmlComponent, canActivate: [AdminGuard] },
     


    { path: 'system-note-manager', component: SystemNoteManagerComponent, canActivate: [AdminGuard] },
//     { path: 'system-action-manager', component: SystemActionManagerComponent },
    { path: 'system-communication-history', component: SystemCommunicationHistoryComponent, canActivate: [AdminGuard] },



    { path: 'brands/companies', component: CompaniesHomeComponent, canActivate: [AdminGuard] },
    { path: 'brands/users', component: UsersListComponent, canActivate: [AdminGuard] },
    { path: 'brands/users/view/:user_id', component: UserViewComponent, canActivate: [AdminGuard] },
    { path: 'brands/users/edit/:user_id', component: UserEditComponent, canActivate: [AdminGuard] },
    { path: 'brands/users/create', component: UserCreateComponent , canActivate: [AdminGuard]},
    { path: 'brands/company/create', component: CompanyCreateComponent , canActivate: [AdminGuard]},
    { path: 'brands/company/view/:brand_id', component: CompanyViewComponent , canActivate: [AdminGuard]},
    { path: 'brands/company/edit/:brand_id', component: CompanyEditComponent, canActivate: [AdminGuard] },

//     // accounting
//     { path: 'accounting', component: AccountingComponent, canActivate: [AdminGuard] },
    { path: 'accounting/invoices', component: InvoicesComponent, canActivate: [AdminGuard] },
//     { path: 'accounting/create-invoice', component: CreateInvoiceComponent, canActivate: [AdminGuard] },
//       // orginal paths
    { path: 'accounting/myob-login', component: MyobLoginComponent, canActivate: [AdminGuard] },
    { path: 'myob-login', component: MyobLoginComponent, canActivate: [AdminGuard] },
//     { path: 'accounting/myob-customers', component: MyobCustomersComponent, canActivate: [AdminGuard] },
//     { path: 'accounting/payments', component: PaymentsComponent, canActivate: [AdminGuard] },
//     { path: 'accounting/payments-bulk', component: PaymentsBulkComponent, canActivate: [AdminGuard] },
//       // Three level navigation
//           // clients
    { path: 'accounting/client/invoices', component: InvoicesComponent, canActivate: [AdminGuard] },
    { path: 'accounting/client/outstandings', component: ClientOutstandingsComponent, canActivate: [AdminGuard] },
    { path: 'accounting/client/paymentbulk', component: PaymentsBulkComponent, canActivate: [AdminGuard] },
    { path: 'accounting/client/myob-customers', component: MyobCustomersComponent, canActivate: [AdminGuard] },
    { path: 'accounting/client/payments', component: PaymentsComponent, canActivate: [AdminGuard] },
//           // agents
    { path: 'accounting/agent/invoices', component: InvoicesSuppliersComponent, canActivate: [AdminGuard] },
    { path: 'accounting/agent/outstandings', component: AgentOutstandingsComponent, canActivate: [AdminGuard] },
    { path: 'accounting/agent/paymentbulk', component: PaymentsBulkSupplierComponent, canActivate: [AdminGuard] },
    { path: 'accounting/agent/myob-customers', component: MyobSuppliersComponent, canActivate: [AdminGuard] },
    { path: 'accounting/agent/payments', component: MyobPaymentsSuppliersComponent, canActivate: [AdminGuard] },




//       // Start of system setting Manger
      { path: 'api-access-services', redirectTo: 'api-access-services/client-api-onboarding', pathMatch: 'full' },
      { path: 'api-access-services/client-api-onboarding', component: ClientApiOnboardingComponent, canActivate: [AdminGuard] },
      { path: 'system-settings', component: SystemSettingsComponent, canActivate: [AdminGuard] },
      { path: 'system-settings/client-api-onboarding', redirectTo: 'api-access-services/client-api-onboarding', pathMatch: 'full' },
      { path: 'system-settings/dbe-rest', component: DbeRestAdminComponent, canActivate: [AdminGuard] },
    
      { path: 'system-settings/job-types', component: SystemJobTypesComponent, canActivate: [AdminGuard] },
      { path: 'system-settings/job-types/locations/:job_type_id', component: SystemJobTypeLocationsComponent, canActivate: [AdminGuard] },
      { path: 'system-settings/job-types/locations/courts/:job_type_location_id',
       component: SystemLocationCourtsComponent, canActivate: [AdminGuard] },
       { path: 'system-settings/job-types/locations/courts/document-types/:job_type_court_id',
       component: SystemCourtDocumentTypesComponent, canActivate: [AdminGuard] },
       { path: 'system-settings/job-types/locations/courts/document-types/affidavits/:job_type_document_type_id',
       component: SystemDocumentTypeAffidavitsComponent, canActivate: [AdminGuard] },

      //  { path: 'system-settings/job-types/locations/courts/document-types/service-rules/:job_type_document_type_id',
      //  component: SystemDocumentServiceRulesComponent, canActivate: [AdminGuard] },

       { path: 'system-settings/job-service-rules', component: SystemJobServiceRulesComponent, canActivate: [AdminGuard] },
       { path: 'system-settings/job-service-timeframes', component: SystemJobServiceTimeframesComponent, canActivate: [AdminGuard] },
       { path: 'system-settings/subject-service-types', component: SystemSubjectServiceTypesComponent, canActivate: [AdminGuard] },
       { path: 'system-settings/job-status-codes', component: CreateJobStatusComponent, canActivate: [AdminGuard] },
    

       { path: 'system-settings/subject-service-types', component: SystemSubjectServiceTypesComponent, canActivate: [AdminGuard] },
       { path: 'system-settings/timeframe-surcharges', component: TimeframeSurchargesComponent, canActivate: [AdminGuard] },


       { path: 'system-settings/system-log-types', component: SystemLogTypesComponent, canActivate: [AdminGuard] },
       { path: 'system-settings/system-log-type/edit/:log_type_id', component: UpdateSystemLogTypeComponent, canActivate: [AdminGuard] },

       { path: 'system-settings/accounting/billing-tasks', component: AccountingBillingTasksComponent, canActivate: [AdminGuard] },
       { path: 'system-settings/accounting/cost-tasks', component: AccountingCostTasksComponent, canActivate: [AdminGuard] },

       { path: 'system-settings/accounting/myob-account-codes', component: AccountingMyobAccountCodesComponent, canActivate: [AdminGuard] },
       { path: 'system-settings/accounting/myob-tax-codes', component: AccountingMyobTaxCodesComponent, canActivate: [AdminGuard] },


       { path: 'system-settings/attempt-resolution-outcomes', component: SubjectServiceResolutionOutcomesComponent, canActivate: [AdminGuard] },



       { path: 'system-automations', component: SystemAutomationsComponent, canActivate: [AdminGuard] },
       { path: 'system-automations/view', component: SystemAutomationsComponent, canActivate: [AdminGuard] },
       { path: 'system-automations/create', component: SystemAutomationCreateComponent, canActivate: [AdminGuard] },
       { path: 'system-automations/update/:system_automation_id', component: SystemAutomationUpdateComponent, canActivate: [AdminGuard] },
       { path: 'system-automations/view/:system_automation_id', component: SystemAutomationComponent, canActivate: [AdminGuard] },
      //  { path: 'system-automations/system-action-lists', component: SystemActionListsComponent, canActivate: [AdminGuard] },

     
 

      { path: 'system-automations/system-log-type/:log_type_id', component: SystemLogTypeComponent, canActivate: [AdminGuard] },
      { path: 'system-automations/system-log-types', component: SystemLogTypesComponent, canActivate: [AdminGuard] },
      { path: 'system-automations/system-log-type/edit/:log_type_id', component: UpdateSystemLogTypeComponent, canActivate: [AdminGuard] },

      //new
      { path: 'system-automations/system-log-types/view', component: SystemLogTypesComponent, canActivate: [AdminGuard] }, // must be first.
      { path: 'system-automations/system-log-types/:log_type_id', component: SystemLogTypeComponent, canActivate: [AdminGuard] },
      { path: 'system-automations/system-log-types/edit/:log_type_id', component: UpdateSystemLogTypeComponent, canActivate: [AdminGuard] },



      { path: 'system-automations/system-log-type-data-sectors', component: SystemLogTypeDataSectorsComponent, canActivate: [AdminGuard] },
      { path: 'system-automations/system-log-type-data-sectors/view', component: SystemLogTypeDataSectorsComponent, canActivate: [AdminGuard] },
      { path: 'system-automations/system-log-type-data-sectors/:log_type_data_sector_id', component: SystemLogTypeDataSectorComponent, canActivate: [AdminGuard] },
      { path: 'system-automations/system-log-type-data-sectors/update/:log_type_data_sector_id', component: SystemLogTypeDataSectorUpdateComponent, canActivate: [AdminGuard] },

      
      { path: 'system-automations/system-log-type-data-sectors/system-log-type-data-sector-conditions', component: SystemLogTypeDataSectorConditionsComponent, canActivate: [AdminGuard] },
      { path: 'system-automations/system-log-type-data-sectors/system-log-type-data-sector-conditions/view', component: SystemLogTypeDataSectorConditionsComponent, canActivate: [AdminGuard] },
      { path: 'system-automations/system-log-type-data-sectors/system-log-type-data-sector-conditions/:log_type_data_sector_condition_id', component: SystemLogTypeDataSectorConditionComponent, canActivate: [AdminGuard] },
      { path: 'system-automations/system-log-type-data-sectors/system-log-type-data-sector-conditions/update/:log_type_data_sector_condition_id', component: SystemLogTypeDataSectorConditionUpdateComponent, canActivate: [AdminGuard] },


      { path: 'system-automations/system-log-type-data-sector-conditions', component: SystemLogTypeDataSectorConditionsComponent, canActivate: [AdminGuard] },
      { path: 'system-automations/system-log-type-data-sector-conditions/view', component: SystemLogTypeDataSectorConditionsComponent, canActivate: [AdminGuard] },
      { path: 'system-automations/system-log-type-data-sector-conditions/update/:log_type_data_sector_condition_id', component: SystemLogTypeDataSectorConditionUpdateComponent, canActivate: [AdminGuard] },
      

      { path: 'system-automations/system-log-type-data-sectors/system-log-type-data-sector-types', component: SystemLogTypeDataSectorTypesComponent, canActivate: [AdminGuard] },
      { path: 'system-automations/system-log-type-data-sectors/system-log-type-data-sector-types/view', component: SystemLogTypeDataSectorTypesComponent, canActivate: [AdminGuard] },
      { path: 'system-automations/system-log-type-data-sectors/system-log-type-data-sector-types/:log_type_data_sector_type_id', component: SystemLogTypeDataSectorTypeComponent, canActivate: [AdminGuard] },
      { path: 'system-automations/system-log-type-data-sectors/system-log-type-data-sector-types/update/:log_type_data_sector_type_id', component: SystemLogTypeDataSectorTypeUpdateComponent, canActivate: [AdminGuard] },

      { path: 'system-automations/service-outcome-templates', component: SubjectServiceOutcomeTemplatesComponent, canActivate: [AdminGuard] },
      { path: 'system-automations/service-outcome-templates/view', component: SubjectServiceOutcomeTemplatesComponent, canActivate: [AdminGuard] },
      { path: 'system-automations/service-outcome-templates/:ssot_id', component: SubjectServiceOutcomeTemplateComponent, canActivate: [AdminGuard] },
      { path: 'system-automations/service-outcome-templates/update/:ssot_id', component: SubjectServiceOutcomeTemplateUpdateComponent, canActivate: [AdminGuard] },

      // subjects urgent outcome templates.
      { path: 'system-automations/subject-urgent-outcome-templates', component: SubjectUrgentOutcomeTemplatesComponent, canActivate: [AdminGuard] },
      { path: 'system-automations/subject-urgent-outcome-templates/view', component: SubjectUrgentOutcomeTemplatesComponent, canActivate: [AdminGuard] },
      { path: 'system-automations/subject-urgent-outcome-templates/:suot_id', component: SubjectUrgentOutcomeTemplateComponent, canActivate: [AdminGuard] },
      { path: 'system-automations/subject-urgent-outcome-templates/update/:suot_id', component: SubjectUrgentOutcomeTemplateUpdateComponent, canActivate: [AdminGuard] },


         // Variable code blocks
    { path: 'system-variables/variable-code-blocks', component: VariableCodeBlocksComponent },
    { path: 'system-variables/variable-code-blocks/home', component: VariableCodeBlocksComponent },
    { path: 'system-variables/variable-code-blocks/create', component: VariableCodeBlockCreateComponent },
    { path: 'system-variables/variable-code-blocks/update/:variable_code_block_id', component: VariableCodeBlockUpdateComponent },


       { path: 'system-investigation', component: SystemInvestigationComponent, canActivate: [AdminGuard] },
       { path: 'system-investigation/begin', component: SystemInvestigationComponent, canActivate: [AdminGuard] },
       { path: 'system-investigation/system-action-lists', component: SystemActionListsComponent, canActivate: [AdminGuard] },

       { path: 'system-investigation/system-action-list/:action_list_id', component: SystemActionListComponent, canActivate: [AdminGuard] },

//       // Start of system reports
//       { path: 'system-reports', component: SystemReportsComponent, canActivate: [AdminGuard] },
      { path: 'system-reports/jobs-subjects-created-report', component: JobsSubjectsCreatedReportComponent, canActivate: [AdminGuard] },
      { path: 'system-reports/agent-performance-metrics', component: AgentPerformanceMetricsComponent, canActivate: [AdminGuard] },
      { path: 'system-reports/client-performance-metrics', component: ClientPerformanceMetricsComponent, canActivate: [AdminGuard] },

      { path: 'system-reports/staff-performance-metrics/original', component: StaffPerformanceMetricsComponent, canActivate: [AdminGuard] },
      { path: 'system-reports/new-system-contacts-report', component: NewSystemContactsReportComponent, canActivate: [AdminGuard] },
      { path: 'system-reports/new-system-contacts-report/report-new-agent-contacts',component: ReportNewAgentContactsComponent , canActivate: [AdminGuard] },
      { path: 'system-reports/system-log', component: SystemLogManagerComponent , canActivate: [AdminGuard] },
      { path: 'system-reports/system-log/:log_id', component: SystemLogViewComponent , canActivate: [AdminGuard] },

      { path: 'system-reports/system-files',component: SystemFileManagerComponent , canActivate: [AdminGuard] },

      { path: 'system-reports/dbe-rest-report',component: DbeRestReportComponent , canActivate: [AdminGuard] },


      { path: 'system-reports/staff-performance-metrics', component: StaffPerformanceMetricsDashboardComponent, canActivate: [AdminGuard] },
      { path: 'system-reports/staff-performance-metrics/saved', component: StaffPerformanceMetricsSavedDashboardComponent, canActivate: [AdminGuard] },


      { path: 'system-reports/agent-performance-metrics/dashboard', component: AgentPerformanceMetricsDashboardComponent, canActivate: [AdminGuard] },
      { path: 'system-reports/agent-performance-metrics/saved', component: AgentPerformanceMetricsSavedDashboardComponent, canActivate: [AdminGuard] },
      { path: 'system-reports/agent-performance-metrics/attempts', component: AgentPerformanceMetricsAttemptsDashboardComponent, canActivate: [AdminGuard] },
      { path: 'system-reports/agent-performance-metrics/attempt-benchmarks', component: AgentPerformanceMetricsAttemptBenchmarksComponent, canActivate: [AdminGuard] },

        // Agent Activity Metrics Performance 2026
      { path: 'system-reports/agent-performance-activity-metrics/attempts', component: AgentPerformanceActivityMetricsAttemptsComponent, canActivate: [AdminGuard] },
      { path: 'system-reports/agent-performance-activity-metrics/attempts-classic', component: AgentPerformanceActivityMetricsAttemptAttemptsComponent, canActivate: [AdminGuard] },
      { path: 'system-reports/agent-performance-activity-metrics/attempts-indexed', component: AgentPerformanceActivityMetricsAttemptsIndexedComponent, canActivate: [AdminGuard] },
      { path: 'system-reports/agent-performance-activity-metrics/dashboard-indexed', component: AgentPerformanceActivityMetricsDashboardIndexedComponent, canActivate: [AdminGuard] },
      { path: 'system-reports/agent-performance-activity-metrics/progress', component: AgentPerformanceActivityMetricsProgressComponent, canActivate: [AdminGuard] },





        
      { path: 'system-reports/client-performance-metrics/saved', component: ClientPerformanceMetricsSavedDashboardComponent, canActivate: [AdminGuard] },



        // New October 24 Actity and Performance Reporting Section
      { path: 'system-reports/activity/dashboard', component: SystemActivityDashbardComponent , canActivate: [AdminGuard] },


        { path: 'system-reports/activity/benchmarks', component: LogTypeBenchmarksComponent , canActivate: [AdminGuard] },
        { path: 'system-reports/activity/benchmarks/update/:log_type_benchmark_id', component: LogTypeBenchmarkUpdateComponent , canActivate: [AdminGuard] },
        { path: 'system-reports/activity/benchmarks/view/:log_type_benchmark_id', component: LogTypeBenchmarkComponent , canActivate: [AdminGuard] },

      
        { path: 'system-reports/activity/kpi/groups', component:BenchmarkpiGroupsComponent , canActivate: [AdminGuard] },
        { path: 'system-reports/activity/kpi/group/view/:benchmark_kpi_group_id', component:BenchmarkpiGroupViewComponent , canActivate: [AdminGuard] },
        { path: 'system-reports/activity/kpi/group/update/:benchmark_kpi_group_id', component:BenchmarkpiGroupUpdateComponent , canActivate: [AdminGuard] },

        // job scheduler and cron system
      { path: 'system-reports/subjects_urgent_schedules',component: SubjectsUrgentExportJobSchedulesComponent , canActivate: [AdminGuard] },


          // App Routes
    { path: 'system-routes/app-routes', component: AppRoutesComponent, canActivate: [ AdminGuard] },
    { path: 'system-routes/app-routes/view/:app_route_id', component: AppRouteComponent, canActivate: [AdminGuard] },
    { path: 'system-routes/app-routes/home', component: AppRoutesComponent , canActivate: [ AdminGuard]},
    { path: 'system-routes/app-routes/create', component: AppRouteCreateComponent, canActivate: [ AdminGuard] },
    { path: 'system-routes/app-routes/update/:app_route_id', component: AppRouteUpdateComponent },


          // App Projects
          { path: 'projects', component: ProjectsHomeComponent, canActivate: [AdminGuard] },
          { path: 'projects/projects-home', component: ProjectsHomeComponent, canActivate: [AdminGuard] },
          { path: 'projects/projects-edit/:project_id', component: ProjectsEditComponent, canActivate: [AdminGuard] },
          { path: 'projects/project/:project_id', component: ProjectAdminViewComponent, canActivate: [AdminGuard] },
          // { path: 'projects/old', component: ProjectsComponent, canActivate: [AdminGuard] },



// system notices
{ path: 'system-notices', component: SystemNoticesComponent, canActivate: [AdminGuard] },
{ path: 'system-notices/home', component: SystemNoticesComponent, canActivate: [AdminGuard] },
{ path: 'system-notices/create', component: SystemNoticeCreateComponent, canActivate: [AdminGuard] },
{ path: 'system-notices/banner/:id', component: SystemNoticeBannerComponent, canActivate: [AdminGuard] },
{ path: 'system-notices/update/:id', component: SystemNoticeUpdateComponent, canActivate: [AdminGuard] },


  ] 
},




  // Administration NEW CLIENT
  {
    path: 'client', component: ClientLayoutComponent, canActivate: [ClientGuard],
    children: [
      // { path: '', component: ClientDashboardComponent, canActivate: [ClientGuard] },
      { path: '', component: LoginEnterCodeTFAComponent, canActivate: [ClientGuard] },

      { path: 'tfa_setup', component: LoginUserSetupTFAComponent, canActivate: [ClientGuard] }, // Now initalise  a 2fa here.
      { path: 'tfa_enter_code', component: LoginEnterCodeTFAComponent, canActivate: [ClientGuard] }, // Now initalise  a 2fa here.

      { path: 'dashboard', component: ClientDashboardComponent, canActivate: [ClientGuard] },
      // { path: 'stats', component: ClientStatsComponent },
      // // { path: 'traces', component: ClientTracesComponent },
      // // { path: 'traces-company', component: ClientBrandTracesComponent },
      // // { path: 'traces-search', component: ClientTracesSearchComponent },
      // { path: 'traces-search-subjects', component: ClientSubjectsSearchComponent },
      // { path: 'client-brand-card/:client_brand_id', component: ClientBrandCardComponent },
      // { path: 'client-brand-card/:brand_id/:client_brand_id', component: ClientBrandCardComponent },
      // // { path: 'client-brand-card/update/contact/:client_brand_id', component: ClientBrandContactUpdateComponent },
      // // Start of SOP
      { path: 'jobs', component: ClientJobsComponent, canActivate: [ClientGuard] },
      { path: 'jobs/my-jobs', component: ClientJobsComponent, canActivate: [ClientGuard] },
      { path: 'subjects/my-subjects', component: ClientJobsUrgentComponent, canActivate: [ClientGuard] },
        { path: 'subjects/timeframes', component: ClientJobsUrgentTimeframesComponent, canActivate: [ClientGuard] },

      { path: 'jobs/create-job', component: ClientJobCreateComponent, canActivate: [ClientGuard] },
      { path: 'jobs/create-job-step-2/:job_id', component: ClientJobCreate2Component, canActivate: [ClientGuard] },
      { path: 'jobs/create-job-step-3/:job_id', component: ClientJobCreate3Component , canActivate: [ClientGuard]},
      { path: 'jobs/view-job/:job_id', component: ClientJobViewComponent, canActivate: [ClientGuard] },
      { path: 'jobs/subject/:subject_id', component: ClientJobSubjectComponent, canActivate: [ClientGuard] },
      { path: 'jobs/job-status-key', component: ClientJobStatusKeyWidgetComponent, canActivate: [ClientGuard] },

      { path: 'profile/:brand_id', component: ClientProfileComponent, canActivate: [ClientGuard] },
      { path: 'profile/edit/:brand_id', component: ClientProfileEditComponent, canActivate: [ClientGuard] },
      { path: 'user/profile/:user_id', component: ClientUserProfileComponent, canActivate: [ClientGuard] },
      { path: 'user/profile/edit/:user_id', component: ClientUserProfileEditComponent, canActivate: [ClientGuard] },
      { path: 'users', component: ClientUsersComponent, canActivate: [ClientGuard] },
      { path: 'invoices', component: ClientInvoicesComponent, canActivate: [ClientGuard] },

      { path: 'jobs/create-job-wizard', component: ClientJobCreateWizardStep1Component , canActivate: [ClientGuard]},
      { path: 'jobs/create-job-wizard-step-2/:job_id', component: ClientJobCreateWizardStep2Component , canActivate: [ClientGuard]},
      { path: 'jobs/create-job-wizard-step-3/:job_id', component: ClientJobCreateWizardStep3Component , canActivate: [ClientGuard]},
    ]
  },




  // Agent NEW Proper
  {
    path: 'agent', component: AgentLayoutComponent, canActivate: [AgentGuard],
    children: [
      // { path: '', component: AgentComponent, canActivate: [AgentGuard] },
      { path: '', component: LoginEnterCodeTFAComponent, canActivate: [AgentGuard] },

      { path: 'dashboard', component: AgentComponent, canActivate: [AgentGuard] },


      { path: 'tfa_setup', component: LoginUserSetupTFAComponent, canActivate: [AgentGuard] }, // Now initalise  a 2fa here.
      { path: 'tfa_enter_code', component: LoginEnterCodeTFAComponent, canActivate: [AgentGuard] }, // Now initalise  a 2fa here.

      { path: 'jobs', component: AgentJobsComponent, canActivate: [AgentGuard] },
        { path: 'subjects/timeframes', component: AgentJobsUrgentTimeframesComponent, canActivate: [AgentGuard] },
    
    
      //   /* {path: 'jobs/create-job', component: CreateJobComponent, canActivate: [ AdminGuard]},
    //   {path: 'jobs/agrid', component: AgridComponent, canActivate: [ AdminGuard]},
    //   {path: 'jobs/create-job-2/:job_id', component: CreateJob2Component, canActivate: [ AdminGuard]},
    //   {path: 'jobs/create-job-3/:job_id', component: CreateJob3Component, canActivate: [ AdminGuard]},
    //   {path: 'clients', component: ClientsComponent},
    //   {path: 'clients/create-client', component: ClientCreateComponent},
    //   {path: 'clients/contacts/:client_id', component: ClientContactsSharmansComponent},
    //   {path: 'jobs/edit/:job_id', component: EditJobComponent, canActivate: [ AdminGuard]},
    //   {path: 'jobs/create-job-type', component: CreateJobTypeComponent, canActivate: [ AdminGuard]},
    //   {path: 'jobs/create-job-status', component: CreateJobStatusComponent, canActivate: [ AdminGuard]}, */
    //   /*
    //    {path: 'jobs/view/history/:job_id', component: JobHistoryComponent, canActivate: [ AdminGuard]},
 
    //    {path: 'jobs/home', component: JobsHomeComponent, canActivate: [ AdminGuard]},
    //    {path: 'jobs/subject/edit/:subject_id', component: SubjectEditComponent, canActivate: [ AdminGuard]},*/

    //    // old links and above for AUSTRACE
      { path: 'jobs/subject/view/:subject_id', component: AgentViewSubjectComponent, canActivate: [AgentGuard] },
    //  // { path: 'jobs/view/:job_id', component: JobViewComponent, canActivate: [] },

      { path: 'jobs/view-job/:job_id', component: AgentJobViewComponent, canActivate: [AgentGuard] },
       { path: 'jobs/subject/:subject_id', component: AgentJobSubjectComponent, canActivate: [AgentGuard] },
    //    /*  { path: 'profile/:brand_id', component: ClientProfileComponent },
    //   { path: 'profile/edit/:brand_id', component: ClientProfileEditComponent },
    //   { path: 'user/profile/:user_id', component: ClientUserProfileComponent },
    //   { path: 'user/profile/edit/:user_id', component: ClientUserProfileEditComponent },*/

      { path: 'profile/:brand_id', component: AgentProfileComponent, canActivate: [AgentGuard] },
      { path: 'profile/edit/:brand_id', component: AgentProfileEditComponent , canActivate: [AgentGuard]},
      { path: 'user/profile/:user_id', component: AgentUserProfileComponent, canActivate: [AgentGuard] },
      { path: 'user/profile/edit/:user_id', component: AgentUserProfileEditComponent, canActivate: [AgentGuard] },
      { path: 'users', component: AgentUsersComponent, canActivate: [AgentGuard] },
      { path: 'invoices', component: AgentInvoicesComponent , canActivate: [AgentGuard]},


    ]
  },


  // {
  //   path: '', component: BlankLayoutComponent,
  //   children: [
  //     { path: 'lost-password', component: LostPasswordComponent },
  //     { path: 'lost-password/:expiry_token/:user_id', component: LostPasswordComponent },
  //   ]
  // },








{
  path: 'mailmerge', component: AdminLayoutComponent, canActivate: [AdminGuard],
  children: [
    { path: '', component: TxcMailMergeComponent },
    // { path: 'jobs', component: JobsHomeComponent },
  ]
},



// { path: 'mailmerge', component: TxcMailMergeComponent}, // test mail merge and asp all in one.

{ path: 'lost-password', component: LostPasswordComponent },
{ path: 'lost-password/:expiry_token/:user_id', component: LostPasswordComponent },

  { path: '', redirectTo: '/login', pathMatch : 'full'},
   { path: '**', redirectTo: '/login', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }
